import React from 'react'
import '../../dist/msgsend.css'

const Msgsend = () => {
  return (
    <span className="loader"></span>
  )
}

export default Msgsend